// extracted by mini-css-extract-plugin
export default {"container":"styles_container__NhYWH","surveyHeading":"styles_surveyHeading__LfNjl","videoContainer":"styles_videoContainer__njsyq"};